/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useRef, useState ,useEffect} from 'react'
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';

const DropDownComponent = ({
    options,
    dropdownkey,
    index,
    obj,
    handleDropDownValue,
    listWidth,
    placeholder,
    selectedvalue, 
    title,
    divClassName,
    outSideClickTriggered,
    showErrorBorder,
    isMandatoryField,
    stateStatus,
    applyBGForDisabled,
    displayAbove}) => {
    const [showDropdown, setshowDropdown] = useState(false)
    const [focusedIndex, setFocusedIndex] = useState(-1);
    const selectedRef  = useRef();
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);
    const optionsRef = useRef([]);

    useOnClickOutside(selectedRef, () => {
        setshowDropdown(false)
        setFocusedIndex(-1);
    });

    const calculateDropdownPosition = () => {
        if (buttonRef.current && dropdownRef.current) {
            const buttonRect = buttonRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - buttonRect.bottom;
            const dropdownHeight = dropdownRef.current.clientHeight;
        
            if (spaceBelow < dropdownHeight && dropdownHeight < buttonRect.top) {
                dropdownRef.current.style.top = `-${dropdownHeight}px`;
            } else {
                dropdownRef.current.style.top = '100%';
            }
        }
    };

    useEffect(() => {
        if(showDropdown){
            window.addEventListener('resize', calculateDropdownPosition);
            calculateDropdownPosition()
            return () => {
                window.removeEventListener('resize', calculateDropdownPosition);
            };
        }
    }, [showDropdown]);

    useEffect(()=>{
        setshowDropdown(false)
        setFocusedIndex(-1);
    }, [outSideClickTriggered])

    useEffect(() => {
        if (focusedIndex !== -1 && optionsRef.current[focusedIndex]) {
            optionsRef.current[focusedIndex].scrollIntoView({
                block: 'nearest',
            });
        }
    }, [focusedIndex]);

    const handleKeyDown = (e) => {
        if ((e.key === 'Enter' || e.key === 'Return') && !showDropdown) {
            e.preventDefault();
            setshowDropdown(true);
            setTimeout(() => dropdownRef.current?.focus(), 0);
        } else if (e.key === 'Escape' || e.key === 'Tab') {
            setshowDropdown(false);
            setFocusedIndex(-1);
        }
    };

    const handleListKeyDown = (e) => {
        e.stopPropagation();
        if (e.key === 'Escape' || e.key === 'Tab') {
            setshowDropdown(false);
            setFocusedIndex(-1);
            buttonRef.current.focus();
            return;
        }
    
        if (options.length > 0) {
            switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setFocusedIndex((prevIndex) =>
                    prevIndex < options.length - 1 ? prevIndex + 1 : 0
                );
                break;
            case 'ArrowUp':
                e.preventDefault();
                setFocusedIndex((prevIndex) =>
                    prevIndex > 0 ? prevIndex - 1 : options.length - 1
                );
                break;
            case 'Enter':
            case 'Return':
                e.preventDefault();
                if (focusedIndex !== -1) {
                    handleDropDownValue(dropdownkey, options[focusedIndex], index);
                    setshowDropdown(false);
                    setFocusedIndex(-1);
                    buttonRef.current.focus();
                } else {
                    setshowDropdown(false);
                    setFocusedIndex(-1);
                    buttonRef.current.focus();
                }
                break;
            default:
                break;
            }
        } else if (e.key === 'Enter' || e.key === 'Return') {
            e.preventDefault();
            setshowDropdown(false);
            setFocusedIndex(-1);
            buttonRef.current.focus();
        }
    };
    
    const handleOptionClick = (item) => {
        handleDropDownValue(dropdownkey, item, index)
        setshowDropdown(false)
        setFocusedIndex(-1);
    }

    return (
        <div className={divClassName !=undefined ? divClassName : 'w-full relative'} ref={selectedRef}>
            <button
                data-testid ="feeterm"  
                ref={buttonRef}
                disabled={stateStatus}
                onClick={() => {
                    const isOpening = !showDropdown;
                    setshowDropdown(isOpening);
                    if (isOpening) {
                        setTimeout(() => dropdownRef.current?.focus(), 0);
                    }
                }}
                onKeyDown={handleKeyDown}
                className={`slct-inpt-fld transition duration-150 ease-in-out ${showErrorBorder == true ? 'redBorder' : ''} 
                ${(isMandatoryField!=undefined && isMandatoryField === true) ? ' error_border ' : ''} 
                ${stateStatus && applyBGForDisabled?'bg-[#E6E8EA]':'bg-white'}`}
                type="button" 
                id={dropdownkey} 
            >
                <p className={`text-f7 w-[88%] ${(selectedvalue === '' || selectedvalue === undefined) ? 'text-[#818E98]' : 'text-[#031624]'} font-normal text-start`} title={(selectedvalue === '' || selectedvalue === undefined) ? placeholder : (title != undefined ? title :selectedvalue)}>{(selectedvalue === '' || selectedvalue === undefined) ? placeholder : selectedvalue}</p>
                <img src="/images/dropdown-icon.png" alt="icon" className={`absolute top-[50%] -translate-y-[50%] dropdown-close right-3 ${showDropdown ? "transform rotate-180" : ""}`}/>
            </button>
            <ul  
                ref={dropdownRef} 
                tabIndex="-1"
                onKeyDown={handleListKeyDown}
                className={`ant-picker-dropdown slct_drp_dwn ${showDropdown ? 'show' : 'hidden'} ${obj} ${displayAbove&&"top-[38px]"} [&[data-te-dropdown-show]]:block ${listWidth !== undefined ? `w-[${listWidth}]` : 'min-w-full'}`}
                style={{outline: 'none'}}
                aria-labelledby={dropdownkey}
                data-te-dropdown-menu-ref>
                <li className={'max-h-[150px] overflow-auto scroll-bar w-full'} >
                    {obj !== undefined ?
                        <ul>
                            {options?.length > 0 ? (
                                options?.map((item, i) => (
                                    <li 
                                        key={item.item_name}
                                        ref={el => optionsRef.current[i] = el}
                                        className={`${focusedIndex === i ? 'bg-gray-100' : ''}`}
                                    >
                                        <p
                                            title={obj === true ? `${item.item_name} ${`(${item.item_code})`}` : item[obj]}
                                            className="slct_drp_dwn_optn"
                                            style={{ display: 'flex', alignItems: 'center' }}
                                            onClick={() => handleOptionClick(item)}
                                        >
                                            {(obj === true ? `${item.item_name} (${`(${item.item_code})`}` : item[obj]) === (title || selectedvalue)
                                                ? <img src="/images/bluedot.svg" alt="selected" className="mr-2 shrink-0"/>
                                                : <div className="w-[7px] h-[6px] mr-2 shrink-0"></div>
                                            }
                                            <span>{obj === true ? `${item.item_name} ${`(${item.item_code})`}` : item[obj]}</span>
                                        </p>
                                    </li>))) :
                                (
                                    <li
                                        key=""
                                        id="select-option"
                                        onClick={(e) => {
                                            setshowDropdown(false);
                                        }}
                                    >
                                        <p className="slct_drp_dwn_optn">
                                            - No options available -
                                        </p>
                                    </li>
                                )}
                        </ul>
                        :
                        <ul>
                            {options.map((item, i) => (
                                <li 
                                    key={item}
                                    ref={el => optionsRef.current[i] = el}
                                    className={`${focusedIndex === i ? 'bg-gray-100' : ''}`}
                                >
                                    <p 
                                        title={item}
                                        className="slct_drp_dwn_optn"
                                        style={{ display: 'flex', alignItems: 'center' }}
                                        onClick={() => handleOptionClick(item)}
                                    >
                                        {item === (title || selectedvalue)
                                            ? <img src="/images/bluedot.svg" alt="selected" className="mr-2 shrink-0"/>
                                            : <div className="w-[7px] h-[6px] mr-2 shrink-0"></div>
                                        }
                                        <span>{item}</span>
                                    </p>
                                </li>))}
                        </ul>}
                </li>
            </ul>
        </div>
    )
}

export default DropDownComponent